module.exports = __webpack_public_path__ + "img/vote.8d0bae7b.png";